import { APIPost } from '../utils/SingleLoginApi'

export const sendMFACode = (username: string): Promise<void> => {
  return APIPost(`api/sso/auth/send-mfa-code/${encodeURIComponent(username)}`)
}
